import InFeedAdsenseComponent from './InFeedAdsenseComponent.vue'

const InFeedAdsense = {
  install: Vue => {
    Vue.component('InFeedAdsense', InFeedAdsenseComponent)
  }
}

export default InFeedAdsense
